/**
 * TimingMetrics - stores a list of timing metrics
 */

export class TimingMetrics {
    constructor() {
        this.metrics = {};
        this.count = 0;
    }

    add(timingCategory, timingVar, timingMillis) {
        const key = timingCategory + '_' + timingVar;
        let timings = this.metrics[key];
        if (!timings) {
            timings = [];
            this.metrics[key] = timings;
        }
        timings.push(timingMillis);
        this.count += 1;
    }

    clear() {
        this.metrics = {};
        this.count = 0;
    }

    getAll() {
        return this.metrics;
    }

    getCount() {
        return this.count;
    }
}

export default TimingMetrics;
